import React from 'react';
import './FilterTags.css';

const FilterTags = ({ activeFilters, removeFilter, clearAllFilters }) => {
  if (activeFilters.length === 0) return null;

  return (
    <div className="filter-tags">
      <span className="tags-label">Active Filters:</span>
      <div className="tags-container">
        {activeFilters.map((filter, index) => (
          <span key={`${filter.type}-${filter.value}-${index}`} className="filter-tag">
            {filter.label}
            <button 
              className="remove-tag"
              onClick={() => removeFilter(filter.type, filter.value)}
            >
              ✕
            </button>
          </span>
        ))}
        <button className="clear-all-tags" onClick={clearAllFilters}>
          Clear All
        </button>
      </div>
    </div>
  );
};

export default FilterTags;
